import React from 'react';
import {
  Route,
  Switch,
  useParams,
  Link,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { observer } from 'mobx-react';
import * as CONSTANTS from 'Utils/constants';
// import { ReactComponent as TripleDotNavIcon } from 'Assets/svg/triple-dot-nav.svg';
import { ReactComponent as LeftArrowIcon } from 'Assets/svg/left-arrow-thicker.svg';
import { ReactComponent as DisconnectIcon } from 'Assets/svg/disconnect.svg';
import LoadingWrapper from 'Components/common/loadingWrapper';
import SideBarNavigation from 'Components/common/sideBarNavigation';
import Button from 'Components/common/Button';
import crmIntegrationState from 'Stores/crmIntegration';
import fieldMappingState from 'Stores/fieldMapping';
import { FieldMapping } from './fieldMapping';
import CRMSettings from './crmSettings';
import integrationDataMap from './integrationDataMap';
import 'Styles/layout/_integrationDetail.scss';
import { PageNotFound } from '../pageNotFound/pageNotFound';

function IntegrationRoutePaths(props) {
  const { redirectToIntegrations, crmType } = props;
  return (
    <Switch>
      <Route
        path="/integrations/:crmType/field-mapping/:mappingType"
        exact
        render={routeProps => (
          <FieldMapping
            {...routeProps}
            redirectToIntegrations={redirectToIntegrations}
          />
        )}
      />
      {crmType === 'SALESFORCE' && (
        <Route
          path="/integrations/:crmType/settings"
          exact
          render={routeProps => (
            <CRMSettings
              {...routeProps}
              redirectToIntegrations={redirectToIntegrations}
            />
          )}
        />
      )}
    </Switch>
  );
}

const IntegrationDetail = observer(() => {
  const { crmType, mappingType = '', menu: selectedMenu } = useParams();
  const crmData = integrationDataMap[crmType?.toUpperCase()];
  const history = useHistory();
  const location = useLocation();

  const redirectToIntegrations = () => {
    history.push(CONSTANTS.PAGE_PATH_MAP.INTEGRATIONS);
  };

  const currentCRMData = crmData;

  const isValidRoute = currentCRMData.sublinks.some(subLink =>
    subLink?.subMenu?.length > 0
      ? subLink.subMenu.some(menu => menu.link === location.pathname)
      : subLink.linkValue === location.pathname,
  );
  return isValidRoute ? (
    <div className="integration-detail-page">
      <LoadingWrapper show={fieldMappingState.isLoading} position="fixed" />
      <div className="left-section">
        <Link to="/integrations" className="go-back-link">
          <LeftArrowIcon />
          <span className="go-back-text">Go Back</span>
        </Link>
        <SideBarNavigation
          collapseInactiveMenu
          data={currentCRMData}
          activeMenu={selectedMenu}
          selectedSubMenu={mappingType}
          connectionStatus="Connected"
        >
          <Button
            svg={<DisconnectIcon />}
            className="disconnect-btn"
            btnText="Disconnect"
            click={async () => {
              fieldMappingState.isLoading = true;
              await crmIntegrationState.disconnectCrm(crmType?.toUpperCase());
              fieldMappingState.isLoading = false;
              if (!crmIntegrationState.crmConnectionStatus.SALESFORCE)
                redirectToIntegrations();
            }}
          />
        </SideBarNavigation>
      </div>
      <div className="main-section">
        <IntegrationRoutePaths
          crmType={crmType?.toUpperCase()}
          redirectToIntegrations={redirectToIntegrations}
        />
      </div>
    </div>
  ) : (
    <PageNotFound />
  );
});

export default IntegrationDetail;
